import axios from "axios";
import { message } from "antd";

export const BACK_API = () => {
  const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "",
    timeout: 10000,
    withCredentials: true,
  });


  api.interceptors.request.use(async (config) => {
    if (["post", "put", "delete", "patch"].includes(config.method)) {
      try {
        const response = await axios.get("/csrf-token", {
          withCredentials: true,
          baseURL: process.env.REACT_APP_API_URL || "",
        });

        config.headers["CSRF-Token"] = response.data.csrfToken;
      } catch (error) {
        message.error("Error de seguridad: No se pudo obtener el token CSRF");
        console.error("Error obteniendo token CSRF:", error);
      }
    }
    return config;
  });

  return api;
};

export default BACK_API;
